import Help from "containers/Help/Help";
import withHeader from "hocs/withHeader";
import withFooter from "hocs/withFooter";

const HelpPage = withHeader(withFooter(Help));

export default HelpPage;
